import type { ReactNode } from 'react';

interface BrowserToolbarProps {
    search: ReactNode;
    children: ReactNode;
}

// In a narrow window the controls wrap onto a second line instead of squeezing the search box.
export function BrowserToolbar({ search, children }: BrowserToolbarProps) {
    return (
        <div className="flex min-h-[52px] shrink-0 flex-wrap items-center gap-x-4 gap-y-2 border-b border-gray-100 px-5 py-2">
            {search}
            <div className="ml-auto flex min-w-0 flex-wrap items-center justify-end gap-x-3 gap-y-2">
                {children}
            </div>
        </div>
    );
}
